import {CLEAR_DEVICE_INFO, SELECT_DEVICE_INFO} from '../../../actionType';

export default function (state = {}, action) {
    switch (action.type) {
        case SELECT_DEVICE_INFO:
            return {
                ...state,
                key:action.key,
                deviceModelId:action.deviceModelId,
                deviceModel:action.deviceModel,
                manufacturerId:action.manufacturerId,
                manufacturerName:action.manufacturerName,
                supplierId:action.supplierId,
                supplierName:action.supplierName,
                supplierTin:action.supplierTin,
                devicePrice:action.devicePrice,
                stock:action.stock,
            };
        case CLEAR_DEVICE_INFO:
            return {};
        default:
            return state;
    }
}
